<template>
  <Modal
      v-model="_value"
      width="600"
      title="查看/修改车辆分组信息"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Form ref="loginForm" :model="vehicleInfoGroup" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 80px;">车辆分组名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleInfoGroup.name"
               placeholder="请输入车辆分组名称">
        </Input>
      </FormItem>
      <FormItem prop="parentVehicleInfoGroupId">
        <label style="display: inline-block; width: 80px;">父级车辆分组</label>
        <Select :disabled="!modify"
                style="display: inline-block; width: 200px;"
                v-model="vehicleInfoGroup.parentGroupId"
                filterable
                clearable
                remote
                :remote-method="searchGroup"
                :loading="searchGroupLoading">
          <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
        </Select>
        <Button :disabled="!modify" type="primary" style="display: inline-block; margin-left: 5px;" @click="onClear">清空</Button>
      </FormItem>
      <FormItem prop="remark">
        <label style="display: inline-block; width: 80px;">备注</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="vehicleInfoGroup.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
      <FormItem prop="description">
        <label style="display: inline-block; width: 80px;">描述</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="vehicleInfoGroup.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
    <label>关联主动通知用户列表</label>
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="forwardlyNoticeUsers" ref="table"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="搜索用户">
        <Select
            v-model="selectClients"
            multiple
            filterable
            remote
            :remote-method="searchClients"
            :loading="searchClientLoading">
          <Option v-for="(option, index) in searchClientList" :value="option.id" :key="option.id">{{option.nickName}}({{option.mobilePhoneNum}})</Option>
        </Select>
      </Form-item>
    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" @click="batchSetAttention" style="margin-right: 5px;">批量设置重点关注</Button>
      <Button type="primary" @click="batchAddBusinessNotes" style="margin-right: 5px;">批量追加笔记</Button>
      <Button type="primary" @click="onBindClients">绑定</Button>
    </Row>
    <batch-add-vehicle-info-business-note-modal v-if="!isMyGroup" v-model="batchAddVehicleInfoBusinessNoteModal" :initValue="batchAddVehicleInfoBusinessNoteId"></batch-add-vehicle-info-business-note-modal>
    <my-batch-add-vehicle-info-business-note-modal  v-if="isMyGroup" v-model="batchAddVehicleInfoBusinessNoteModal" :initValue="batchAddVehicleInfoBusinessNoteId"></my-batch-add-vehicle-info-business-note-modal>
    <batch-set-attention-modal v-model="batchSetAttentionModal" :initValue="batchSetAttentionId"></batch-set-attention-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import BatchAddVehicleInfoBusinessNoteModal from '@/view/crm/components/batch-add-vehicle-info-business-note-modal'
import MyBatchAddVehicleInfoBusinessNoteModal from '@/view/crm/components/my-batch-add-vehicle-info-business-note-modal'
import BatchSetAttentionModal from '@/view/crm/components/batch-set-attention-modal'

export default {
  name: 'vehicleinfogroupdetailmodal',
  components: {
    BatchAddVehicleInfoBusinessNoteModal,
    MyBatchAddVehicleInfoBusinessNoteModal,
    BatchSetAttentionModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isMyGroup: {
      type: Boolean,
      default: false
    },
    initValue: null,
    parentGroupId: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆分组名不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      // 批量添加笔记
      batchAddVehicleInfoBusinessNoteModal: false,
      batchAddVehicleInfoBusinessNoteId: null,

      // 批量设置重点关注
      batchSetAttentionModal: false,
      batchSetAttentionId: null,

      modify: false,
      searchGroupValue: null,
      searchGroupLoading: false,
      searchGroupList: [],
      forwardlyNoticeUsers: [],
      selectClients: null,
      searchClientLoading: false,
      searchClientList: [],
      listLoadding: false,
      vehicleInfoGroup: {
        id: null,
        name: null,
        remark: null,
        description: null,
        parentGroupId: null,
        parentGroup: null
      },
      columns: [
        {
          title: 'ID',
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 70
        },
        {
          title: '用户名',
          key: 'name',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '昵称',
          key: 'nickName',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '联系电话',
          key: 'mobilePhoneNum',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '提示',
                      content: '<p>确认解除该用户的绑定?</p>',
                      onOk: () => {
                        store.dispatch('VehicleInfoGroupServ_UnBindForwardlyNoticeUsers', {
                          params: { id: this._initValue, userIds: [params.row.id] }
                        }).then(() => {
                          this.$Message.success('解绑成功')
                          this.visibleChange(true)
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {
                      }
                    })
                  }
                }
              }, '解绑')
            ])
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoGroupServ_GetDetail',
      'VehicleInfoGroupServ_ModifyObj',
      'VehicleInfoGroupServ_SearchByName'
    ]),
    attentionAll (val) {
      if (val) {

      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认将组内车辆全部取消重点关注？</p>',
          onOk: () => {
            store.dispatch('InstallOrderServ_ConfirmInstalled', { params: this.installOrder }).then(() => {
              this.$Message.success('取消关注成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    batchSetAttention () {
      this.batchSetAttentionModal = true
      this.batchSetAttentionId = this._initValue
    },
    batchAddBusinessNotes () {
      this.batchAddVehicleInfoBusinessNoteModal = true
      this.batchAddVehicleInfoBusinessNoteId = this._initValue
    },
    onBindClients () {
      if (!this.selectClients) {
        this.$Message.error('请选择需要绑定的用户')
        return
      }
      // let userIds =this.selectClients.map(item => {return item.id})
      store.dispatch('VehicleInfoGroupServ_BindForwardlyNoticeUsers', {
        params: { id: this._initValue, userIds: this.selectClients },
        urlparams: null
      }).then(() => {
        this.$Message.success('绑定成功')
        this.visibleChange(true)
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    searchClients (input) {
      this.searchClientLoading = true
      if (!input || input.length <= 0) {
        this.searchClientList = []
        this.searchClientLoading = false
      } else {
        store.dispatch('ClientServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientList = store.getters.get_Client_SearchByNameResult ? store.getters.get_Client_SearchByNameResult : []
          this.searchClientLoading = false
        }).catch(err => {
          this.searchClientLoading = false
        })
      }
    },
    onClear () {
      this.vehicleInfoGroup.parentVehicleInfoGroupId = null
    },
    searchGroup (input) {
      console.log(input)
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改车辆分组',
          content: '<p>确认修改车辆分组</p>',
          onOk: () => {
            store.dispatch('VehicleInfoGroupServ_ModifyObj', {
              params: this.vehicleInfoGroup
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let userId = this._initValue
            store.dispatch('VehicleInfoGroupServ_GetDetail', {
              params: { id: userId }
            }).then(() => {
              this.vehicleInfoGroup = store.getters.get_VehicleInfoGroup_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.vehicleInfoGroup.id = null
        this.vehicleInfoGroup.name = null
        this.vehicleInfoGroup.description = null
        this.vehicleInfoGroup.remark = null

        this.selectClients = []
        this.searchClientList = []
        // this.vehicleInfoGroup.parentGroupId = this.parentGroupId
        let vehicleInfoGroupId = this._initValue
        console.log(vehicleInfoGroupId)
        if (vehicleInfoGroupId) {
          store.dispatch('VehicleInfoGroupServ_GetDetail', {
            params: { id: vehicleInfoGroupId }
          }).then(() => {
            let vehicleInfoGroup = store.getters.get_VehicleInfoGroup_GetDetailResult
            this.forwardlyNoticeUsers = vehicleInfoGroup.forwardlyNoticeUsers
            if (vehicleInfoGroup.parentGroup) {
              console.log(vehicleInfoGroup.parentGroup)
              this.searchGroupList = []
              this.searchGroupList.push(vehicleInfoGroup.parentGroup)
              // this.searchGroupValue = this.searchGroup

              store.dispatch('VehicleInfoGroupServ_GetDetail', {
                params: { id: vehicleInfoGroupId }
              }).then(() => {
                this.vehicleInfoGroup = store.getters.get_VehicleInfoGroup_GetDetailResult
              }).catch(err => {
                this.$Message.error(err)
              })
            } else {
              this.vehicleInfoGroup = vehicleInfoGroup
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _parentGroupId: {
      get () {
        return this.parentGroupId
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
